import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import Support from "./Support";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-support")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Support />
		</ThemeProvider>
	</StrictMode>
);
